/*eslint-disable*/
import React, { useEffect } from 'react'
import { CheckboxMultiselect } from '../../../irmlib/src/components/FormControls/Filter'
import * as constants from '../../../irmlib/src/common/constants'
import { useMergeState } from '../../../irmlib/src/hooks'
import * as gdeTransactions from '../../../services/firestore/gdeTransactions'
import * as gdeTransactionsLite from '../../../services/firestore/gdeTransactionsLite'
import { setBusy, clearBusy } from 'irmlib/containers'
import { useTranslation } from 'react-i18next'
import { persistFilters, getUser } from '../../../redux/global'
import { FormControl } from '@mui/material'
import PropTypes from 'prop-types'
import { OutlinedButton } from 'irmlib/components/Controls'
import { useLocation } from 'react-router-dom'

const initialSate = {
  showTable: false,
  countries: [],
  templates: [],
  templatesForSelect: [],
  workerDetails: [],
  wmsList: [],
  templateTypeList: [],
  selectedWms: '',
  selectedTemplate: '',
  districtsList: [],
  districtSelection: [constants.defaultSelect],
  namePrefix: '',
  workersList: [],
  selectedValue: {},
  selectedStatus: {},
}
  
const JobsFilter = (props) => {
  const [state, setState, getState] = useMergeState(initialSate)
  const { t } = useTranslation()
  const userval = getUser()
  const { country, workerId, district } = userval
  useEffect(() => {
    getDistricts(country)
    getTemplateTypes()
  }, [])

  const location = useLocation()
  const pathParams = location.pathname.split('/')
  const viewActivity = pathParams[1]
  const { selectedDatas } = location.state || {}
  const getDistricts = async (country = '') => {
    setBusy()
    let collection
    if (country) {
      collection = await gdeTransactions.getDistrictsByCountry(country)
    } else {
      collection = await gdeTransactions.getDistricts()
    }
    const districtsList = []
    collection?.forEach((doc) => {
      districtsList.push({ value: doc.data().districtName, label: doc.data().districtName })
    })
    setState({ districtsList: districtsList })
    clearBusy()
  }

  const getTemplateTypes = async () => {
    setBusy()
    const collection = await gdeTransactionsLite.getTemplateTypesForWms('SKP')
    const templateTypes = []
    collection.forEach((doc) => {
      if (doc.data()?.assetType !== 'BOX TRANSMITTAL') {
        templateTypes.push({ value: doc.data().dataEntryType, label: doc.data().dataEntryType })
      }
    })
    setState({ templateTypeList: templateTypes })
    clearBusy()
  }
  const handleSelectedData = (data) => {
    setState({ selectedValue: data })
  }
  const handleSelectedStatus = (data) => {
    setState({ selectedStatus: data })
  }
  const jobPagesPathnames = ['AllOpenJobs', 'ClosedJobs', 'myJobs']
  const isJobPage = jobPagesPathnames.includes(viewActivity)

  const handleCLick = () => {
    if (Object.keys(state?.selectedValue).length === 0) {
      setState({ selectedValue: { District: finalDist } })
      props.selectedData({ ...state.selectedValue, ...state.selectedStatus })
    } else {
      props.selectedData({ ...state.selectedValue, ...state.selectedStatus })
    }
    if (!isJobPage) {
      const storedData = localStorage.getItem('persistFilters')
      const existingData = storedData ? JSON.parse(storedData) : {}
      if (!existingData[viewActivity]) {
        existingData[viewActivity] = {}
      }
      existingData[viewActivity] = {
        workerId: workerId,
        country: country,
        district: state.selectedValue?.District || [district],
        status: state.selectedStatus?.Status || props.defaultStatus
      }
      localStorage.setItem('persistFilters', JSON.stringify(existingData))
    }
  }

  const defDistricts = isJobPage ? [district] : (persistFilters()?.district?.length ? persistFilters()?.district : [district])

  let finalDist

  if (Object.keys(state?.selectedValue).length === 0) {
    finalDist = defDistricts
  } else {
    finalDist = getState()?.selectedValue?.District
  } 

  return (
    <>
      <CheckboxMultiselect
        options={state.districtsList}
        defaultOption={selectedDatas ? [selectedDatas] : finalDist}
        label= {t('Search.District')}
        handleSelect = {handleSelectedData}
        name = 'District'
      />
      { props.activeStatus && props.defaultStatus &&
        <CheckboxMultiselect
          options={props.activeStatus}
          defaultOption= {props.selectedStatus?.length && !(props.selectedStatus.length === 1 && props.selectedStatus[0] === constants.defaultSelect) ? props.selectedStatus : props.defaultStatus}
          label= {t('Search.Status')}
          handleSelect = {handleSelectedStatus}
          name = 'Status'
      />}
      <FormControl sx={{ m: 1, width: '90px', display: 'flex', justifyContent: 'center' }}>
        <OutlinedButton id={'allJobs_createJob'} variant='contained' onClick={handleCLick}>
          forms.Search
        </OutlinedButton>
      </FormControl>
    </>
  )
}

JobsFilter.propTypes = {
  defaultStatus: PropTypes.array,
  activeStatus: PropTypes.array,
  selectedData: PropTypes.func,
  selectedStatus: PropTypes.array
}

export default JobsFilter